class CustomSwatch extends HTMLElement {
  constructor() {
    super();
    this.container = this.closest('main-product, product-card');
    const productJSONHTML = this.container.querySelector('[data-product-json]');
    this.productJSON = productJSONHTML ? JSON.parse(productJSONHTML.innerHTML) : null;
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener('change', e => {
      if (e.target.closest('[type="radio"]')) {
        this.handleOptionChange();
      }
    });

    if (Shopify.currentCountry && Shopify.currentCountry.voltage) {
      this.updateVoltage();
      this.changeCountrySpecificVariantNA();
    } else {
      document.addEventListener('countrySelector.ready', () => {
        this.updateVoltage();
        this.changeCountrySpecificVariantNA();
      });
    }

    this.changeCountrySpecificVariantNA();
  }

  handleOptionChange() {
    const selectId = this.container ? this.container.querySelector('[name="id"]') : null;

    if (this.productJSON && selectId) {
      let option1 = this.container.querySelector('[data-index="option1"]:checked');
      let option2 = this.container.querySelector('[data-index="option2"]:checked');
      let option3 = this.container.querySelector('[data-index="option3"]:checked');

      const selectedValues = [
        {
          value: option1 ? option1.value : null,
          index: 'option1',
        },
        {
          value: option2 ? option2.value : null,
          index: 'option2',
        },
        {
          value: option3 ? option3.value : null,
          index: 'option3',
        },
      ];

      const variant = this.productJSON.variants.find(variant =>
        selectedValues.every(({value, index}) => value === variant[index]),
      );

      if (variant) {
        selectId.value = variant ? variant.id : '';
        selectId.dispatchEvent(new Event('change', {bubbles: true}));

        const options = variant.options;
        let voltage = Shopify.currentCountry?.voltage;

        if (options.includes('110V')) {
          voltage = '110V';
        } else if (options.includes('220V') || options.includes('110V PLUS')) {
          voltage = '220V';
        }
        document.dispatchEvent(new CustomEvent('updateVoltage', {detail: {voltage}}));
      }
    }
  }

  updateVoltage() {
    const voltage = Shopify.currentCountry?.voltage;
    let voltageHandle = toHandle(voltage);
    const voltageIndex = this.productJSON.options.findIndex(option => option === 'Voltage');
    const hasVoltage110VPlus = this.productJSON.variants.some(({options}) => options[voltageIndex] === '110V (PLUS)');
    const $option110VPLUS = this.querySelector('[data-value="110V (PLUS)"]');
    const $option110V = this.querySelector('[data-value="110V"]');

    if (voltage === '110V (PLUS)') {
      if (hasVoltage110VPlus) {
        if ($option110VPLUS) {
          $option110VPLUS.style.display = 'inline-block';
        }

        if ($option110V) {
          $option110V.style.display = 'none';
        }
      } else {
        voltageHandle = '110v';
      }
    }

    if (voltage === '220V' && hasVoltage110VPlus) {
      if ($option110VPLUS) {
        $option110VPLUS.style.display = 'inline-block';
      }

      if ($option110V) {
        $option110V.style.display = 'none';
      }
    }

    const voltageOption = this.querySelector(`[data-value="${voltageHandle}"]`);

    if (voltageOption) {
      voltageOption.setAttribute('checked', true);
      voltageOption.dispatchEvent(new Event('change', {bubbles: true}));
    }
  }

  changeCountrySpecificVariantNA() {
    const hasNA = this.productJSON.variants.some(({title}) => title.includes('N/A'));
    const voltage = Shopify.currentCountry?.voltage ?? '110V';

    if (!hasNA) {
      return;
    }

    const titleNA = voltage === '220V' || voltage.includes('PLUS') ? 'n-a-plus' : 'n-a';
    const option = this.querySelector(`[data-value="${titleNA}"]`);

    if (option) {
      option.setAttribute('checked', true);
      option.dispatchEvent(new Event('change', {bubbles: true}));
    }

    const voltageContainer = this.container.querySelector('.option-voltage-container');
    const propPlug = this.container.querySelector('#propPlug');

    if (voltageContainer) {
      voltageContainer.style.display = 'none';
    }

    if (propPlug) {
      propPlug.remove();
    }
  }
}

class CustomSwatchVoltage extends CustomSwatch {
  constructor() {
    super();
    this.voltageSelect = this.querySelector('.option-voltage-select');
    this.voltageSelectList = this.querySelector('.option-voltage-select-list');
    this.voltageSelectOverlay = this.querySelector('.option-voltage-overlay');
    this.voltageSelectP = this.querySelector('.option-voltage-select-p');

    this._setupEventListeners();
  }

  _setupEventListeners() {
    document.addEventListener('updateVoltage', () => {
      if (this.querySelector('.voltage :checked')) {
        this.querySelector('.option-voltage-select-v').innerHTML = this.querySelector(
          '.voltage :checked',
        ).value.replace('(PLUS)', '');
      }
    });

    if (this.voltageSelect) {
      this.voltageSelect.addEventListener('click', evt => {
        this.voltageSelectList.style.display = 'inline-block';
        this.voltageSelectOverlay.style.display = 'block';
      });
    }

    if (this.voltageSelectOverlay) {
      this.voltageSelectOverlay.addEventListener('click', evt => {
        this.voltageSelectList.style.display = 'none';
        this.voltageSelectOverlay.style.display = 'none';
      });
    }

    this.addEventListener('click', evt => {
      if (evt.target.closest('.product-plug li')) {
        const plug = evt.target.closest('.product-plug li').dataset.plugValue;
        this.updatePlug(plug);
      }
    });
  }

  updatePlug(plug) {
    const productPlugItem = this.querySelectorAll('.product-plug li');
    this.voltageSelect.dataset.plug = plug;
    this.voltageSelectP.innerHTML = plug;
    productPlugItem.forEach(el => el.classList.remove('active'));
    const plugItem = this.querySelector(`[data-plug-value="${plug}"]`);

    if (plugItem) {
      plugItem.classList.add('active');
    }

    document.dispatchEvent(new CustomEvent('updatePlug'));
  }
}

customElements.define('custom-swatch', CustomSwatch);
customElements.define('custom-swatch-voltage', CustomSwatchVoltage);
